const timeoutError = (ms: number, label?: string): Error =>
  label
    ? new Error(`${label} timed out after ${ms}ms`)
    : Object.assign(new Error(`timed out after ${ms}ms`), { name: 'TimeoutError' });

export const withTimeout = <T>(promise: Promise<T>, ms: number, label?: string): Promise<T> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return Promise.race([
    promise.finally(() => clearTimeout(timer)),
    new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(timeoutError(ms, label)), ms);
    }),
  ]);
};
